import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION34: PdfComponent = {
  type: 'section',
  id: 's34',
  title: '34. Costs and Expenses',
  content: [
    {
      type: 'altText',
      id: 's34bullets',
      content: [
        'This Agreement may be executed in any number of counterparts, each of which when executed shall constitute a duplicate original, but all the counterparts shall together constitute the one agreement.',
      ],
      boldFirst: false,
    },
  ],
};
